"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
const theme_palette_1 = require("../../components/theme.palette");
exports.CSS = {
    container: 'c-TagList__selected',
    title: 'c-TagList__selected_title',
    text: 'c-TagList__selected_text',
    tools: 'c-TagList__selected_tools',
    spanomatic: 'c-Span-O-Matic',
};
exports.Style = {
    [exports.CSS.container]: {
        paddingLeft: theme_1.DefaultTheme.space(2),
        paddingRight: theme_1.DefaultTheme.space(2),
        fontSize: '120%',
        backgroundColor: (0, theme_1.rgba)(theme_palette_1.ColorPaletteOrange.C100),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: theme_1.DefaultTheme.space(10),
        minHeight: theme_1.DefaultTheme.space(10),
    },
    [exports.CSS.title]: {
        flex: 1,
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap',
    },
    [exports.CSS.text]: {
        flex: 1,
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap',
        padding: `0 ${theme_1.DefaultTheme.space(1)}`,
    },
    [exports.CSS.tools]: {
        display: 'flex',
    },
    [exports.CSS.spanomatic]: {
        color: `rgb(${theme_palette_1.ColorPaletteRed.A700})`,
    },
};
//# sourceMappingURL=collection.toolbar.style.js.map